import { ref } from "vue";

export const showHeader = ref<boolean>(true)